import { render, staticRenderFns } from "./custom-empty.vue?vue&type=template&id=65b0bc44&scoped=true&"
import script from "./custom-empty.vue?vue&type=script&lang=js&"
export * from "./custom-empty.vue?vue&type=script&lang=js&"
import style0 from "./custom-empty.vue?vue&type=style&index=0&id=65b0bc44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0bc44",
  null
  
)

export default component.exports